import { saveAs } from 'file-saver'

const convertToCSV = (objArray) => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
  let str = ''

  for (let i = 0; i < array.length; i++) {
    let line = ''
    for (const index in array[i]) {
      if (line !== '') line += ';'

      line += array[i][index]
    }

    str += line + '\r\n'
  }

  return str
}

export const exportCSVFile = ({ config, data, headerTitle: fileTitle }) => {
  const { columnsDef } = config

  const items = data.map(({ id, ...other }) => other)
  const headers = columnsDef.map(({ header }) => header)

  // Convert Object to JSON
  const jsonObject = JSON.stringify([headers, ...items])
  const csv = convertToCSV(jsonObject)

  // eslint-disable-next-line no-undef
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const exportedFilename = fileTitle ? +`${fileTitle}.csv` : 'export.csv'

  saveAs(blob, exportedFilename)
}
